import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { adminPath } from '@shared/adminPath'
import { connect } from 'react-redux'
import "./index.css"
import saveIcon from "./images/save-icon.svg"
import editIcon from "./images/edit-icon.svg"
import signIcon from "./images/sign-icon.svg"

import _ from 'lodash'
import { closeLoader, openLoader } from '@actions/loader'
import { withRouter } from '../../utils/withRouter'
import FilterDate from '@components/FilterDate'
import FilterSelect from '@components/FilterSelect'
import FilterText from '@components/FilterText'
import { Cell, Column, Table } from 'fixed-data-table-2'
import Tag from '@shared/Tag'
import { createCertificate, findCertificate, getSubOrdersBySchoolId, getSubOrdersByCertificateId, signCertificate, signingUrlCertificate, updateCertificate, getCertificateSchools } from '../../services/sm-api'
import SelectSchoolInput from '@components/SelectSchoolInput'
import { columns } from "./filter-columns";
import { showToastNotification as stateShowToastNotification } from '../../actions/toastNotification'
import { HeaderCell, TextCell } from './cells'
import { series } from '../ReportFilter/options'
import BreadCrumbs from '../BreadCrumbs'

const OrderCreateCertificate = ({openLoader, closeLoader, schools, showToastNotification, screenType, params, navigate}) => {

  const [subOrderFilters, setSubOrdersFilters] = useState({
    school_id: null,
    order_id: null,
    suborder_id: null,
    grade: null,
    purchase_date: null,
    buyer_cpf: null,
    buyer_cnpj: null,
    buyer_name: null,
    student_name: null,
    date_start: null,
    date_end: null,
  });

  const [certificateData, setCertificateData] = useState(null);
  const [filterSchools, setFilterSchools] = useState('');
  const [selectedSubOrdersIds, setSelectedSubOrdersIds] = useState([]);
  const [subOrders, setSubOrders] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [stopLoadMore, setStopLoadMore] = useState(false);
  const [certificateSchools, setCertificateSchools] = useState([]);
  const currentPage = useRef(1);
  const tableRef = useRef(null);

  const isCreating = useMemo(() => !screenType, [screenType]);
  const isEditing = useMemo(() => screenType === 'editing', [screenType]);
  const isVisualizing = useMemo(() => screenType === 'visualizing', [screenType]);




  const breadcrumbItems = useMemo(() => {
    return [
      {name: 'Certificados de Entrega', link: adminPath('/certificados-entrega/')},
      ...(isCreating ? [{name: 'Gerar Certificado', link: null}] : []),
      ...(isEditing && selectedSchool ? [{name: selectedSchool?.label, link: null}] : []),
      ...(isEditing && certificateData? [{name: certificateData?.name, link: null}] : [])
    ]
  }, [selectedSchool, certificateData, isCreating, isEditing]);

  const tableColumns = useMemo(() => {
    const hideCheckbox = screenType === 'visualizing';
    return columns.filter(c => !(hideCheckbox && c.field === 'checkbox'))
  }, [isEditing, isVisualizing]);

  const filters = [
    {name: 'date', type: 'select-date', grow: true},
    {name: 'school_id', emptyLabel: "Escola", type: 'select-school', options: certificateSchools},
    {name: 'order_id', label: "ID do Pedido", type: 'text', preRequest: (value) => value.replace(/[^0-9]+/g, '')},
    {name: 'sub_order_id', label: "ID do Subpedido", type: 'text', preRequest: (value) => value.replace(/[^0-9]+/g, '')},
    {name: 'serie_id', label: "Código do Ano", type: 'select', options: series, emptyLabel: 'Código do Ano'},
    {name: 'buyer_cpf', label: "CPF do Comprador", type: 'text'},
    {name: 'buyer_cnpj', label: "CNPJ do Comprador", type: 'text'},
    {name: 'student_name', label: "Nome do Estudante", type: 'text'},
    {name: 'buyer_name', label: "Nome do Comprador", type: 'text'}
  ];

  const getSubOrders = useCallback(async (loadingMore = false) => {
    if (!subOrderFilters.school_id || subOrderFilters.school_id <= 0) {
      return;
    }

    if (!loadingMore) {
      currentPage.current = 1;
    }

    openLoader();
    try {
      const requestParams = {
        page: currentPage.current,
        ...(params.certificateId ? {delivery_certificate_id: params.certificateId} : []),
        ...subOrderFilters,
      };

      filters.filter(f => !!requestParams[f.name] && !!Object.keys(requestParams).includes(f.name) && !!f.preRequest).forEach((f => {
        requestParams[f.name] = f.preRequest(requestParams[f.name]);
      }));


      let loadedSubOrders;
      const service = isVisualizing ? getSubOrdersByCertificateId : getSubOrdersBySchoolId;
      const { orders: loaded = [] } = await service(requestParams);
      loadedSubOrders = loaded;

      if(loadedSubOrders.length == 0){
        setStopLoadMore(true);
      }

      setSubOrders(loadingMore ? [...subOrders, ...loadedSubOrders] : loadedSubOrders);

    } catch (e) {
      showToastNotification({
        title: 'Houve um erro',
        text: 'Não foi possível obter os sub pedidos',
        variant: 'error'
      });
      throw e;
    } finally {
      closeLoader();
    }
  }, [subOrderFilters, selectedSubOrdersIds, isVisualizing, subOrders])

  const treatSubOrderId = (suborderId) => {
    return +filters.find(f => f.name === 'sub_order_id').preRequest(suborderId);
  }

  const getHumanableErrorMessage = (eCode) => {
    if (eCode === 409) {
      return 'Não foi possível gerar o certificado pois algum sub pedido já está associado a outro certificado'
    }

    return "Não foi possível gerar o certificado"
  }

  const generateCertificate = async () => {
    openLoader();
    try {
      const params = {
        school_id: subOrderFilters.school_id,
        suborders: selectedSubOrdersIds.map(s => s)
      };

      var cert = await createCertificate(params);

      navigate(adminPath('/certificados-entrega/visualizar/') + cert.certificate.id);
    } catch (e) {
      showToastNotification({
        title: 'Houve um erro',
        text: getHumanableErrorMessage(e.response.status),
        variant: 'error'
      });
    } finally {
      closeLoader();
    }
  }

  const gotSignCertificate = useCallback(async () => {
    openLoader();
    try {
      const result = (certificateData.status === 'generated' || certificateData.status === 'signed')
        ? (await signingUrlCertificate(params.certificateId))
        : (await signCertificate(params.certificateId));
      
      if (result.status !== 'success') {
        throw 'Não foi possível gerar seu certificado para assinatura';
      }

      window.open(result.signing_url, '_blank');

    } catch (e) {
      showToastNotification({
        title: 'Houve um erro',
        text: 'Não foi possível gerar seu certificado para assinatura',
        variant: 'error'
      });
    } finally {
      closeLoader();
    }
  }, [certificateData])

  const updateCertificateSuborders = async () => {
    openLoader();
    try {
      const requestParams = {
        suborders: selectedSubOrdersIds.map(s => s)
      };

      await updateCertificate(params.certificateId, requestParams);
      showToastNotification({
        title: 'Sucesso',
        text: 'As alterações foram salvas com sucesso',
        variant: 'success'
      });

      setTimeout(() => {
        navigate(adminPath(`/certificados-entrega/visualizar/${params.certificateId}`));
      }, 2000);

    } catch (e) {
      showToastNotification({
        title: 'Houve um erro ao salvar',
        text: getHumanableErrorMessage(e.response.status),
        variant: 'error'
      });
      closeLoader();
    } finally {
      
    }
  }

  const saveCertificate = () => {
    if (isEditing) {
      return updateCertificateSuborders();
    }

    generateCertificate();
  }

  const loadMoreSubOrders = async () => {

    if (stopLoadMore) {
      return;
    }

    let currentScroll = tableRef.current.state.boundState.scrollY
    let maxScroll = tableRef.current.state.boundState.maxScrollY
    if (currentScroll === maxScroll) {
      currentPage.current++;
      await getSubOrders(true);
      showToastNotification({
        title: 'Informação',
        text: 'Mais sub pedidos foram carregados',
        variant: 'warning'
      });
    }
  }

  const toggleSelectedSubOrder = (subOrderId) => {
    const newSelectedSubOrdersIds = selectedSubOrdersIds.includes(subOrderId) ?
      selectedSubOrdersIds.filter(id => id !== subOrderId)
        : [...selectedSubOrdersIds, subOrderId];

    setSelectedSubOrdersIds(newSelectedSubOrdersIds);
  }

  const toogleAllSubOrders = () => {
    const newSelectedSubOrdersIds = selectedSubOrdersIds.length < subOrders.length ?
      subOrders.map(order => +order.sub_order_id.replace(/[^0-9]+/g, ''))
      : [];

    setSelectedSubOrdersIds(newSelectedSubOrdersIds);
  }

  // const updateFilters = useCallback(_.debounce(getSubOrders, 1000), [])

  const onChangeFilter = (value, filter) => {
    if (filter.name === 'date') {
      setSubOrdersFilters({...subOrderFilters, ...value});
      return;
    }

    setSubOrdersFilters({...subOrderFilters, [filter.name]: typeof value === 'object' ? value[filter.name] : value});
    // updateFilters();
  }

  const renderFilters = () => (
    filters.map(filter => {
      let disabled = (filter.name !== 'school_id' && !subOrderFilters.school_id) || (filter.name === 'school_id' && !!params.certificateId);
      switch (filter.type) {
        case 'text':
        case 'number':
        default:
          return <FilterText
                    field={filter.name}
                    disabled={disabled}
                    onChange={(value) => onChangeFilter(value, filter)}
                    label={filter.label}
                  />;
        case 'select':
          return <FilterSelect
                    field={filter.name}
                    disabled={disabled}
                    onChange={(value) => onChangeFilter(value, filter)}
                    value={subOrderFilters[filter.name]}
                    emptyLabel={filter.emptyLabel}
                    label={filter.label}
                    options={filter.options}
                  />
        case 'select-school':
          return <SelectSchoolInput
                  value={filterSchools}
                  disabled={disabled}
                  setInputValue={setFilterSchools}
                  setState={(value) => onChangeFilter(value, filter)}
                  schools={filter.options}
                />
        case 'select-date':
          return () => <FilterDate onChange={(value) => onChangeFilter(value, filter)} disabled={disabled} />;
      }
    })
  );

  const goToEdit = () => navigate(adminPath(`/certificados-entrega/editar/${params.certificateId}`));
  const goToManage = () => navigate(adminPath(`/certificados-entrega/visualizar/${params.certificateId}`));

  const onManaging = async () => {
    try {
      const certificate = (await findCertificate(params.certificateId));
      setCertificateData(certificate);

      const currentSchool = schools.find(s => s.value === certificate.school.id);
      setSelectedSchool(currentSchool);
      setFilterSchools(currentSchool.label);

      setSelectedSubOrdersIds(certificate.suborders.map(s => s.suborder_id));
      setSubOrdersFilters({...subOrderFilters, school_id: certificate.school.id});
    } catch (e) {
      throw e;
    } finally {
      closeLoader();
    }
  }




  useEffect(() => {
    if (certificateData && isEditing && certificateData.status === 'signed') {
      navigate(adminPath(`/certificados-entrega/visualizar/${params.certificateId}`));
      return;
    }
  }, [certificateData]);


  useEffect(() => {
    getSubOrders();
  }, [subOrderFilters]);

  
  useEffect(() => {
    if (!subOrderFilters.school_id || subOrderFilters.school_id <= 0) {
      return;
    }

    setSelectedSchool(schools.find(s => s.value === subOrderFilters.school_id))
  }, [subOrderFilters.school_id]);

  useEffect(() => {
    const loadSchools = async () => {
      try {
        const schools = await getCertificateSchools();
        setCertificateSchools(schools);
      } catch (e) {
        showToastNotification({
          title: 'Houve um erro',
          text: 'Não foi possível carregar as escolas',
          variant: 'error'
        });
      }
    };

    loadSchools();
  }, []);

  useEffect(() => {
    if (!isCreating) {
      onManaging();
    }
  }, [isCreating])

  return (
    <>
      <div className="cert-gen__breadcrumb">
        <BreadCrumbs items={breadcrumbItems} />
      </div>
      
      <div className="cert-gen">

        <h3 className="cert-gen__title">
          {!isCreating && <div className="cert-gen__title__school-name">{selectedSchool?.label}</div>}

        <div style={{fontSize: '20px', fontWeight: 'bold', paddingTop: '8px'}}>
          {!isCreating ? certificateData?.name : `Gerar Certificado ${selectedSchool ? selectedSchool?.label : ''}`}
        </div>

        {isEditing || isVisualizing ? (
            <>
              <div style={{ fontSize: '12px', fontWeight: 'normal', paddingTop: '8px' }}>
                {certificateData?.created_at ? new Date(certificateData.created_at).toLocaleString('pt-BR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                }).replace(',', '') : ''}
              </div>

              <div style={{ fontSize: '12px', fontWeight: 'normal', paddingTop: '8px' }}>
                Campanha {certificateData?.campaign_id}
              </div>
            </>
        ) : null}

        </h3>

        {(isCreating || isEditing) && certificateSchools.length > 0 && (
          <div className="cert-gen__filters">
            {renderFilters().map(field => (
              <div className={`cert-gen__filters__item ${typeof field === 'function' && 'cert-gen__filters__item--grow'}`}>
                {typeof field === 'function' ? field() : field}
              </div>
            ))}
          </div>
        )}
        
        {subOrders.length > 0 && (
          <div className="cert-gen__orders-box">
            <Table
              className="orders-table"
              onScrollEnd={() => {
                loadMoreSubOrders();
              }}
              rowHeight={72}
              rowsCount={subOrders.length}
              width={'100%'}
              height={472}
              headerHeight={50}
              data={subOrders}
              ref={tableRef}
            >
              {tableColumns.map((column, key) => (
                <Column
                  key={key}
                  header={
                    <HeaderCell className={column.className || ''}>
                      {column.field === 'checkbox' ?
                            <input
                              type="checkbox"
                              checked={selectedSubOrdersIds.length === subOrders.length && subOrders.length > 1}
                              data-partialy-checked={selectedSubOrdersIds.length >= 1 && selectedSubOrdersIds.length < subOrders.length}
                              onChange={() => toogleAllSubOrders()}
                            />
                          : column.label}
                      </HeaderCell>
                  }
                  columnKey={column.field}
                  cell={cellProps => (
                    <Cell {...cellProps}>
                      {column.field === 'checkbox' ? (
                        <input
                          type="checkbox"
                          checked={selectedSubOrdersIds.includes(treatSubOrderId(subOrders[cellProps.rowIndex].sub_order_id))}
                          onChange={() => toggleSelectedSubOrder(treatSubOrderId(subOrders[cellProps.rowIndex].sub_order_id))}
                        />
                      ) : column.field === 'status' ? (
                        
                        <div className="orders-table__cell">
                          <Tag variant="success" text={column.formatter ? column.formatter(subOrders[cellProps.rowIndex].status) : subOrders[cellProps.rowIndex].status} noPoint />
                        </div>
                      ) : (
                        <TextCell
                          data={subOrders}
                          formatter={column.formatter}
                          fieldName={column.field}
                          className={`column-${column.field}`}
                          {...cellProps}
                        />
                      )}
                    </Cell>
                  )}
                  fixed
                  width={1150 * (column.widthPercent / 100)}
                />
              ))}
            </Table>
            <div className="cert-gen__orders-box__action-buttons">
              {!isVisualizing && !isEditing && (
                <button className="button__medium" type="submit" disabled={!selectedSubOrdersIds.length} onClick={() => saveCertificate()}>
                  Gerar Certificado
                </button>
              )}
              {(isVisualizing && certificateData.status !== 'signed') && (
                <>
                  <button className="button__medium button__normal--white" type="submit" disabled={!selectedSubOrdersIds.length} onClick={() => goToEdit()}>
                    Editar <img src={editIcon} />
                  </button>
                </>
              )}

              {(isVisualizing) && (
                  <button className="button__medium" type="submit" disabled={!selectedSubOrdersIds.length} onClick={() => gotSignCertificate()}>
                    {certificateData?.status === 'signed' ? 'Ver assinatura' : 'Assinar'}
                    <img style={{ marginLeft: '8px' }} src={signIcon} />
                  </button>
              )}

              {isEditing && (
                <>
                  <button className="button__medium button__normal--white" type="submit" disabled={!selectedSubOrdersIds.length} onClick={() => goToManage()} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                    <path d="M10 12L6 8L10 4" stroke="#ec6262" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                    Voltar
                  </button>
                  <button className="button__medium" type="submit" disabled={!selectedSubOrdersIds.length} onClick={() => saveCertificate()}>
                    Salvar alterações <img src={saveIcon} />
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

const mapStateToProps = (state, props) => ({
  params: props.params,
  schools: state.school.schools,
  user: state.sessionReducer.user,
  order: state.order,
})

const mapDispatchToProps =  {
  openLoader,
  closeLoader,
  stateShowToastNotification,
}

const mergeProps = (stateProps, dispatchProps, props) => ({
  ...props,
  showToastNotification: (data) => dispatchProps.stateShowToastNotification(data),
  openLoader: () => dispatchProps.openLoader(),
  closeLoader: () => dispatchProps.closeLoader(),
  user: { ...stateProps.user, ...stateProps.order },
  navigate: props.navigate,
  schools: stateProps.schools,
  params: stateProps.params
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(OrderCreateCertificate))

